import '../../scss/collection_review/index.scss';
import { initFilters } from "../collection/filters";
var slideInterval;
document.addEventListener('DOMContentLoaded', function () {
    var slideIndex = 0;
    var slideShowContainer = document.querySelector('.slideshow-container');
    var slides = slideShowContainer === null || slideShowContainer === void 0 ? void 0 : slideShowContainer.querySelectorAll('.slide');
    initFilters();
    if (slides) {
        initSlideshow(slides, slideIndex);
        toggleSlides(slideShowContainer, slides);
    }
});
var initSlideshow = function (slides, slideIndex) {
    var i;
    var dots = document.querySelectorAll('.slider-pagination .dot');
    for (i = 0; i < slides.length; i++) {
        var slide = slides[i];
        slide.style.display = 'none';
    }
    slideIndex++;
    if (slideIndex > slides.length) {
        slideIndex = 1;
    }
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(' active', '');
    }
    var currentSlide = slides[slideIndex - 1];
    currentSlide.style.display = 'block';
    dots[slideIndex - 1].className += ' active';
    clearInterval(slideInterval);
    slideInterval = setTimeout(function () { return initSlideshow(slides, slideIndex); }, 2000);
};
var toggleSlides = function (slideShowContainer, slides) {
    var arrowLeft = slideShowContainer.querySelector('.iconoir-nav-arrow-left');
    var arrowRight = slideShowContainer.querySelector('.iconoir-nav-arrow-right');
    if (arrowLeft && arrowRight) {
        arrowLeft.addEventListener('click', function () {
            clearInterval(slideInterval);
            previousSlide(slides);
        });
        arrowRight.addEventListener('click', function () {
            clearInterval(slideInterval);
            nextSlide(slides);
        });
    }
};
var nextSlide = function (slides) {
    var slideIndex = Array.from(slides).findIndex(function (slide) { return slide.style.display === 'block'; });
    slideIndex = (slideIndex + 1) % slides.length;
    initSlideshow(slides, slideIndex);
};
var previousSlide = function (slides) {
    var slideIndex = Array.from(slides).findIndex(function (slide) { return slide.style.display === 'block'; });
    slideIndex = (slideIndex - 1 + slides.length) % slides.length;
    initSlideshow(slides, slideIndex);
};
